export default {
  actionIcon: 'StarIcon',
  highlightColor: 'warning',
  data: [
    // {index: 0, label: 'Dashboard', url: '/', labelIcon: 'ActivityIcon', highlightAction: false},
  ]
}
